import Link from "next/link";

export default function Banner({ main_message, cta_message, has_link }) {
  const linkToRedirect =
    "https://pages.talkualfoods.com/benebono-talkual?utm_source=benebono&utm_medium=web";
  return (
    <div className="promotion_banner">
      <p>{main_message}</p>
      {has_link && <Link href={linkToRedirect}>{cta_message}</Link>}
    </div>
  );
}
